// extracted by mini-css-extract-plugin
module.exports = {"no_shipment":"NoShipmentsAvailable_no_shipment__333fX","no_shipment_text":"NoShipmentsAvailable_no_shipment_text__2opqO"};